import { render, staticRenderFns } from "./infoCommunication .vue?vue&type=template&id=d0cd8994&scoped=true&"
import script from "./infoCommunication .vue?vue&type=script&lang=js&"
export * from "./infoCommunication .vue?vue&type=script&lang=js&"
import style0 from "./infoCommunication .vue?vue&type=style&index=0&id=d0cd8994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cd8994",
  null
  
)

export default component.exports